/**
 * Product Variant Selector V2
 * Управление выбором вариантов (вес) и обновлением цены
 */

(function () {
if (window.ProductVariantSelectorV2) {
  if (typeof window.initProductVariantSelectorV2 === 'function') {
    window.initProductVariantSelectorV2();
  }
  return;
}

class ProductVariantSelectorV2 {
  constructor() {
    this.variantSelects = document.querySelector('variant-selects');
    if (!this.variantSelects) return;

    this.productForm = document.querySelector(`#${this.variantSelects.dataset.section}`);
    this.productInfo = document.querySelector(`product-info[data-section="${this.variantSelects.dataset.section}"]`);
    
    this.weightItems = Array.from(document.querySelectorAll('.product-text-weight-item'));
    this.priceElement = document.querySelector('.product-text-price-main');
    this.comparePriceElement = document.querySelector('.product-text-price-sale');
    this.priceContainer = document.querySelector('.product-text-price');
    this.unitPriceElement = document.querySelector(`#unit-price-${this.variantSelects.dataset.section}`);
    this.cornerBadges = document.querySelector('[data-pdp-corner-badges]');
    this.discountBadge = document.querySelector('[data-pdp-discount-badge]');
    this.addToCartButton = document.querySelector('.product-text-buy-btn');
    this.addToCartButtonPrices = document.querySelectorAll('.product-text-buy-btn-price-current');
    this.addToCartButtonComparePrices = document.querySelectorAll('.product-text-buy-btn-price-compare');
    this.variantInput = document.querySelector('input[name="id"]');
    
    this.init();
  }

  init() {
    if (this.weightItems.length === 0) return;

    // Загружаем данные о вариантах
    this.loadVariantData();

    // Добавляем обработчики кликов на варианты веса
    this.weightItems.forEach(item => {
      item.addEventListener('click', (e) => this.handleVariantChange(e.currentTarget));
    });
  }

  loadVariantData() {
    // Получаем JSON с вариантами из скрипта на странице
    const variantScript = document.querySelector('script[data-selected-variant]');
    if (variantScript) {
      try {
        this.currentVariant = JSON.parse(variantScript.textContent);
      } catch (e) {
        console.error('Error parsing variant data:', e);
      }
    }

    // Получаем все варианты продукта
    if (typeof window.productVariants !== 'undefined') {
      this.variants = window.productVariants;
    } else {
      // Если глобальные варианты не определены, пытаемся получить их из product-info
      this.fetchVariants();
    }
  }

  async fetchVariants() {
    const productUrl = this.variantSelects.dataset.url;
    if (!productUrl) return;

    try {
      const response = await fetch(`${productUrl}.js`);
      const productData = await response.json();
      this.variants = productData.variants;
    } catch (error) {
      console.error('Error fetching product variants:', error);
    }
  }

  handleVariantChange(selectedItem) {
    const optionIndex = selectedItem.dataset.variantOption;

    // Меняем активное значение только внутри выбранной группы опций.
    this.weightItems
      .filter(item => item.dataset.variantOption === optionIndex)
      .forEach(item => {
      item.classList.remove('active');
      item.setAttribute('aria-pressed', 'false');
    });
    
    // Добавляем активное состояние к выбранному
    selectedItem.classList.add('active');
    selectedItem.setAttribute('aria-pressed', 'true');

    const selectedOptions = this.weightItems
      .filter(item => item.classList.contains('active'))
      .sort((a, b) => Number(a.dataset.variantOption) - Number(b.dataset.variantOption))
      .map(item => item.dataset.variantValue);

    // Находим точный вариант по полной комбинации опций.
    const selectedVariant = this.findVariantByOptions(selectedOptions);
    
    if (selectedVariant) {
      this.updateProduct(selectedVariant);
    }
  }

  findVariantByOptions(selectedOptions) {
    if (!this.variants) return null;

    return this.variants.find(variant => selectedOptions.every((value, index) => {
      const variantValue = variant.options?.[index] ?? variant[`option${index + 1}`];
      return variantValue === value;
    })) || null;
  }

  updateProduct(variant) {
    if (!variant) return;

    if (this.addToCartButton) {
      this.addToCartButton.classList.remove('is-subscribed');
      this.addToCartButton.removeAttribute('aria-disabled');
    }

    // Обновляем основную цену
    if (this.priceElement) {
      const formattedPrice = this.formatMoney(variant.price);
      this.priceElement.textContent = formattedPrice;
      this.priceElement.dataset.price = variant.price;
    }

    // Обновляем старую цену и скидочный бейдж
    const hasComparePrice = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);
    if (this.comparePriceElement) {
      if (hasComparePrice) {
        this.comparePriceElement.textContent = this.formatMoney(variant.compare_at_price);
      }
      this.comparePriceElement.hidden = !hasComparePrice;
    }
    this.priceContainer?.classList.toggle('has-old-price', hasComparePrice);

    if (this.discountBadge) {
      if (hasComparePrice) {
        const percentage = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
        this.discountBadge.textContent = `-${percentage}%`;
      }
      this.discountBadge.hidden = !hasComparePrice;
    }

    if (this.cornerBadges) {
      const hasNewBadge = this.cornerBadges.dataset.hasNew === 'true';
      this.cornerBadges.hidden = !hasComparePrice && !hasNewBadge;
      this.cornerBadges.classList.toggle('has-discount', hasComparePrice);
    }

    // Обновляем цену за единицу (за кг)
    if (this.unitPriceElement && variant.unit_price) {
      const unitPrice = this.formatMoney(variant.unit_price);
      const unitMeasurement = variant.unit_price_measurement?.reference_unit || 'kg';
      this.unitPriceElement.textContent = `${unitPrice} / ${unitMeasurement}`;
      this.unitPriceElement.hidden = false;
    } else if (this.unitPriceElement) {
      this.unitPriceElement.hidden = true;
    }

    // Обновляем кнопку "В корзину"
    if (this.addToCartButton) {
      const buttonText = this.addToCartButton.querySelector('.t2');

      if (variant.available) {
        this.addToCartButton.disabled = false;
        this.addToCartButton.classList.remove('back-in-stock-trigger', 'is-subscribed');
        this.addToCartButton.removeAttribute('data-back-in-stock');
        this.addToCartButton.removeAttribute('data-variant-id');
        this.addToCartButton.removeAttribute('data-product-url');
        this.addToCartButton.removeAttribute('aria-disabled');
        if (buttonText) {
          buttonText.textContent = this.getTranslation('addToCart');
        }
        this.addToCartButton.dataset.price = variant.price;
      } else {
        this.addToCartButton.disabled = false;
        this.addToCartButton.classList.add('back-in-stock-trigger');
        this.addToCartButton.setAttribute('data-back-in-stock', '');
        this.addToCartButton.dataset.variantId = String(variant.id);
        this.addToCartButton.dataset.productUrl = `${this.addToCartButton.dataset.productBaseUrl}?variant=${variant.id}`;
        if (buttonText) {
          buttonText.textContent = this.getTranslation('notifyMe');
        }
      }
    }

    // Обновляем цену в кнопке
    if (this.addToCartButtonPrices && this.addToCartButtonPrices.length) {
      this.addToCartButtonPrices.forEach((priceElement) => {
        priceElement.textContent = this.formatMoney(variant.price);
      });
    }

    if (this.addToCartButtonComparePrices && this.addToCartButtonComparePrices.length) {
      this.addToCartButtonComparePrices.forEach((priceElement) => {
        if (hasComparePrice) {
          priceElement.textContent = this.formatMoney(variant.compare_at_price);
        }
        priceElement.hidden = !hasComparePrice;
      });
    }

    // Обновляем скрытое поле с ID варианта
    if (this.variantInput) {
      this.variantInput.value = variant.id;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Обновляем изображение если у варианта есть свое изображение
    if (variant.featured_media) {
      this.updateMainImage(variant.featured_media);
    }

    // Обновляем URL
    this.updateURL(variant.id);

    // Отправляем событие об изменении варианта
    this.dispatchVariantChangeEvent(variant);
  }

  updateMainImage(media) {
    const mainImage = document.querySelector('#MainProductImage-' + this.variantSelects.dataset.section);
    if (!mainImage || !media) return;

    const newImageUrl = media.src || media.preview_image?.src;
    if (newImageUrl) {
      mainImage.src = newImageUrl;
    }

    // Обновляем активную точку галереи
    const thumbnails = document.querySelectorAll('.product-image-tumb-img');
    thumbnails.forEach((thumb) => {
      const isActive = String(thumb.dataset.mediaId) === String(media.id);
      thumb.classList.toggle('active', isActive);
      thumb.setAttribute('aria-pressed', String(isActive));
    });
  }

  updateURL(variantId) {
    if (!variantId) return;
    
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  }

  dispatchVariantChangeEvent(variant) {
    document.dispatchEvent(new CustomEvent('variant:change', {
      detail: { variant },
      bubbles: true
    }));
  }

  formatMoney(cents) {
    const locale = (typeof document !== 'undefined' && document.documentElement?.lang) || 'de-DE';
    const amount = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
    const moneySample = window.theme?.moneySample;
    const sampleAmount = moneySample?.match(/[0-9][0-9.,]*/)?.[0];

    if (moneySample && sampleAmount) {
      return moneySample.replace(sampleAmount, amount);
    }

    // Используем Shopify.formatMoney если доступен
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || '{{amount}}');
    }
    
    return `€${amount}`;
  }

  getTranslation(key) {
    // Используем глобальные переводы если доступны
    if (typeof window.variantStrings !== 'undefined') {
      return window.variantStrings[key] || key;
    }
    
    // Fallback переводы (camelCase ключи как в window.variantStrings)
    const translations = {
      addToCart: 'В корзину',
      soldOut: 'Ausverkauft',
      notifyMe: 'Wieder da?'
    };
    
    return translations[key] || key;
  }
}

window.ProductVariantSelectorV2 = ProductVariantSelectorV2;

function initProductVariantSelectorV2() {
  window.__frostixProductVariantSelectorInstance = new ProductVariantSelectorV2();
  return window.__frostixProductVariantSelectorInstance;
}

window.initProductVariantSelectorV2 = initProductVariantSelectorV2;

// Инициализация при загрузке DOM
document.addEventListener('DOMContentLoaded', () => {
  initProductVariantSelectorV2();
});

// Экспорт для использования в других скриптах
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ProductVariantSelectorV2;
}
})();
